import { render, staticRenderFns } from "./cloudOfficeHome.vue?vue&type=template&id=37bad3e4&scoped=true&"
import script from "./cloudOfficeHome.vue?vue&type=script&lang=js&"
export * from "./cloudOfficeHome.vue?vue&type=script&lang=js&"
import style0 from "./cloudOfficeHome.vue?vue&type=style&index=0&id=37bad3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bad3e4",
  null
  
)

export default component.exports